// UI Overlay Managers matching the Labonno Lover layout

export const promptManager = {
  show(key = 'E', text = 'Interact') {
    const el = document.getElementById('prompt');
    const keyEl = document.getElementById('prompt-key');
    const textEl = document.getElementById('prompt-text');
    if (el) {
      const isTouch = (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        window.matchMedia('(pointer: coarse)').matches
      );
      // On mobile / touchscreen devices, map keyboard 'E' to mobile Nintendo button 'A'
      const displayKey = isTouch && (key === 'E' || key === 'e') ? 'A' : key;
      if (keyEl) keyEl.innerText = displayKey;
      if (textEl) textEl.innerText = text;
      el.classList.remove('hidden');
    }
  },
  hide() {
    const el = document.getElementById('prompt');
    if (el) el.classList.add('hidden');
  }
};

export const enemyBarManager = {
  show(name = 'ROYAL VANGUARD', currentHp = 100, maxHp = 100) {
    const el = document.getElementById('enemybar');
    const nameEl = document.getElementById('enemy-name');
    const fillEl = document.getElementById('enemy-hp-fill');
    if (el) {
      if (nameEl) nameEl.innerText = name;
      if (fillEl) {
        const pct = Math.max(0, Math.min(100, (currentHp / maxHp) * 100));
        fillEl.style.width = `${pct}%`;
      }
      el.classList.remove('hidden');
    }
  },
  updateHp(currentHp, maxHp) {
    const fillEl = document.getElementById('enemy-hp-fill');
    if (fillEl) {
      const pct = Math.max(0, Math.min(100, (currentHp / maxHp) * 100));
      fillEl.style.width = `${pct}%`;
    }
  },
  hide() {
    const el = document.getElementById('enemybar');
    if (el) el.classList.add('hidden');
  }
};

export const cinematicManager = {
  show(eyebrow, title, sub, duration = 3000, onComplete = null) {
    const el = document.getElementById('cinematic');
    const eyeEl = document.getElementById('cinematicEyebrow');
    const titleEl = document.getElementById('cinematicTitle');
    const subEl = document.getElementById('cinematicSub');

    if (el) {
      if (eyeEl) eyeEl.innerText = eyebrow;
      if (titleEl) titleEl.innerText = title;
      if (subEl) subEl.innerText = sub;

      el.classList.remove('hidden');
      void el.offsetWidth;
      el.classList.add('active');

      if (duration > 0) {
        setTimeout(() => {
          el.classList.remove('active');
          setTimeout(() => {
            el.classList.add('hidden');
            if (onComplete) onComplete();
          }, 800);
        }, duration);
      }
    }
  },
  hide() {
    const el = document.getElementById('cinematic');
    if (el) {
      el.classList.remove('active');
      setTimeout(() => el.classList.add('hidden'), 500);
    }
  }
};

export const playerBarManager = {
  setLovePercent(percent) {
    const fill = document.getElementById('hud-player-bar');
    if (fill) {
      fill.style.width = `${Math.max(0, Math.min(100, percent))}%`;
    }
  }
};
